const CDN = 'https://rustic-summit-wko.cdn.modulify.website/images/portfolio'

export const media = {
    heroImage: `${CDN}/hero-ocean-waves.jpg`,
    ogImage: `${CDN}/workspace-code-editor.jpg`,
    portrait: `${CDN}/zaki-hatta-portrait.png`,
    workspaceTyping: `${CDN}/workspace-typing.jpg`,
    workspaceDesk: `${CDN}/workspace-minimal-desk.jpg`,
    coastline: `${CDN}/coast-aerial-beach.jpg`,
    resultsBackground: `${CDN}/workspace-code-editor.jpg`,
    footerImage: `${CDN}/workspace-wooden-desk.jpg`
}
